<script>

    import { createEventDispatcher } from 'svelte';
    /**
     * @typedef {Object} Props
     * @property {any} action
     * @property {number} [currentSize]
     * @property {boolean} [noAriaRole]
     * @property {any} [role]
     */
    let {
        action,
        currentSize = 0,
        noAriaRole = false,
        role = null
    } = $props();

    const dispatch = createEventDispatcher();

    function handleMenuItemClick(e) {
        e.stopImmediatePropagation();
        dispatch('click', { action, dataSet: e.target.dataset });
    }
</script>

<li
    class="floating-menu-row interactive"
    role={noAriaRole ? null : role ?? 'menuitem'}
>
    <button
        onclick={handleMenuItemClick}
        data-size="0"
        class="interactive size {currentSize === 0 ? 'selected' : ''}"
        style="padding:0.05rem;"
></button>

    <button
        onclick={handleMenuItemClick}
        data-size="1"
        class="interactive size {currentSize === 1 ? 'selected' : ''}"
        style="padding:0.1rem;"
></button>

    <button
        onclick={handleMenuItemClick}
        data-size="2"
        class="interactive size {currentSize === 2 ? 'selected' : ''}"
        style="padding:0.2rem;"
></button>

    <button
        onclick={handleMenuItemClick}
        data-size="3"
        class="interactive size {currentSize === 3 ? 'selected' : ''}"
        style="padding:0.3rem;"
></button>

    <button
        onclick={handleMenuItemClick}
        data-size="4"
        class="interactive size {currentSize === 4 ? 'selected' : ''}"
        style="padding:0.4rem;"
></button>

    <button
        onclick={handleMenuItemClick}
        data-size="5"
        class="interactive size {currentSize === 5 ? 'selected' : ''}"
        style="padding:0.5rem;"
></button>
</li>

<style>
    .floating-menu-row {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        max-width: 20rem;
        color: #eee;
        padding: 1rem;
    }

    .floating-menu-row:hover {
        background-color: rgba(0, 0, 0, 0.3);
    }

    .size {
        display: flex;
        width: 1rem;
        height: 1rem;
        border-radius: 10rem;
        outline: 3px solid rgba(255, 255, 255, 0);
        background-color: #666;
    }

    .size.selected {
        outline: 3px solid rgba(255, 255, 255, 1);
    }

    .size:hover {
        outline: 3px solid rgba(255, 255, 255, 1);
    }

    .size:not(:last-of-type) {
        margin-right: 0.25rem;
    }
</style>
